import logger from '../../../../../core/utils/src/logger';
var getHtmlElement = function () { return document.querySelector('html'); };
function getBrowserLocale() {
    return new Intl.DateTimeFormat().resolvedOptions().locale;
}
function checkLocale(locale) {
    // Support underscore-delimeted locales, as provided by mezzanine
    locale = locale && locale.replace(/^([a-z]{2})_/, '$1-');
    // Check that the value matches aa-BB pattern
    // TODO: support full BCP 47 spec?
    if (locale && !locale.match(/^[a-z]{2}(-[A-Z]{2})?$/)) {
        logger.warn("Invalid locale provided: " + locale + ". Falling back to default");
        locale = '';
    }
    return locale;
}
export function mergeLocales(locale, fullLocale) {
    var isShort = locale.length === 2;
    if (isShort && fullLocale.indexOf(locale) === 0) {
        return fullLocale;
    }
    return locale;
}
export function normalizeLocale(locale) {
    locale = checkLocale(locale);
    var browserLocale = getBrowserLocale();
    if (locale) {
        return mergeLocales(locale, browserLocale);
    }
    var htmlLocale = checkLocale(getHtmlElement().getAttribute('lang'));
    if (htmlLocale) {
        return mergeLocales(htmlLocale, browserLocale);
    }
    return browserLocale;
}
//# sourceMappingURL=locales.js.map